// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_17QVQ","avatar":"index_avatar_1zJMr"};